export const COMPANY_ADMIN_SIDEBAR_GROUPS = [
  {
    id: 'workspace',
    items: [
      { id: 'company-portfolio', label: 'Portfolio', icon: 'bi-briefcase', route_name: 'CompanyPortfolio' },
      { id: 'company-cases', label: 'Cases', icon: 'bi-folder2-open', route_name: 'CompanyCases' },
      { id: 'company-inbox', label: 'Inbox', icon: 'bi-inboxes', route_name: 'CompanyInbox' },
      { id: 'company-messages', label: 'Messages', icon: 'bi-chat-dots', route_name: 'CompanyMessages' },
      { id: 'panel-register', label: 'Panel Register', icon: 'bi-people', route_name: 'PanelRegister' },
      { id: 'time-sheets', label: 'Timesheets', icon: 'bi-clock-history', route_name: 'TimeSheets' },
      { id: 'audit-log', label: 'Audit Log', icon: 'bi-journal-text', route_name: 'AuditLog' },
      { id: 'company-reports', label: 'Reports', icon: 'bi-bar-chart', route_name: 'CompanyReports' },
      { id: 'tenant-settings', label: 'Tenant Settings', icon: 'bi-sliders', route_name: 'TenantSettings' },
      { id: 'config', label: 'Config', icon: 'bi-gear', external_system: 'config', admin_only: true },
    ],
  },
];

export const CASE_OWNER_WORK_ITEMS = [
  { id: 'owner-overview', label: 'Overview', icon: 'bi-grid-3x3-gap', route_name: 'OwnerDashboard', count: null },
  { id: 'owner-all-cases', label: 'All cases', icon: 'bi-file-earmark', route_name: 'OwnerQueue', count: null },
  { id: 'owner-inbox', label: 'Inbox', icon: 'bi-file-earmark', route_name: 'OwnerInbox', count: null },
  { id: 'owner-messages', label: 'Messages', icon: 'bi-person', route_name: 'OwnerMessages', count: null },
  { id: 'owner-calendar', label: 'Calendar', icon: 'bi-clock', route_name: 'OwnerCalendar', count: null },
  { id: 'owner-time-entry', label: 'Time entry', icon: 'bi-clock', route_name: 'OwnerTimeEntry', count: null },
  { id: 'owner-reports', label: 'Reports', icon: 'bi-bar-chart', route_name: 'CompanyReports', count: null },
];

export const REQUESTOR_WORK_ITEMS = [
  { id: 'requestor-overview', label: 'Overview', icon: 'bi-grid-3x3-gap', route_name: 'RequestorPortal', count: null },
  { id: 'requestor-all-cases', label: 'All cases', icon: 'bi-file-earmark', route_name: 'OwnerQueue', count: null },
  { id: 'requestor-inbox', label: 'Inbox', icon: 'bi-file-earmark', route_name: 'OwnerInbox', count: null },
  { id: 'requestor-messages', label: 'Messages', icon: 'bi-person', route_name: 'OwnerMessages', count: null },
  { id: 'requestor-calendar', label: 'Calendar', icon: 'bi-clock', route_name: 'OwnerCalendar', count: null },
  { id: 'requestor-time-entry', label: 'Time entry', icon: 'bi-clock', route_name: 'OwnerTimeEntry', count: null },
  { id: 'requestor-reports', label: 'Reports', icon: 'bi-bar-chart', route_name: 'OwnerReports', count: null },
];

export const INTAKE_OFFICER_WORK_ITEMS = [
  { id: 'intake-queue', label: 'Intake queue', icon: 'bi-grid-3x3-gap', route_name: 'IntakeDesk', count: null },
  { id: 'registered-cases', label: 'Registered cases', icon: 'bi-file-earmark', route_name: 'CoordinatorRegisteredCases', count: null },
  { id: 'intake-inbox', label: 'Inbox', icon: 'bi-file-earmark', route_name: 'CoordinatorInbox', count: null },
  { id: 'intake-messages', label: 'Messages', icon: 'bi-person', route_name: 'CompanyMessages', count: null },
  { id: 'intake-reports', label: 'Intake reports', icon: 'bi-bar-chart', route_name: 'CompanyReports', count: null },
];

export const COORDINATOR_WORK_ITEMS = [
  { id: 'coordinator-dashboard', label: 'Scope dashboard', icon: 'bi-grid-3x3-gap', route_name: 'ScopeDashboard', count: null },
  { id: 'coordinator-cases', label: 'Cases in scope', icon: 'bi-file-earmark', route_name: 'CompanyCases', count: null },
  { id: 'coordinator-intake', label: 'Intake & register', icon: 'bi-plus-lg', route_name: 'IntakeDesk', count: null },
  { id: 'coordinator-inbox', label: 'Inbox', icon: 'bi-file-earmark', route_name: 'CoordinatorInbox', count: null },
  { id: 'coordinator-messages', label: 'Messages', icon: 'bi-person', route_name: 'CompanyMessages', count: null },
  { id: 'coordinator-calendar', label: 'Calendar', icon: 'bi-clock', route_name: 'OwnerCalendar', count: null },
  { id: 'coordinator-panel', label: 'Assigned panel', icon: 'bi-person', route_name: 'PanelRegister', count: null },
  { id: 'coordinator-timesheets', label: 'Timesheets', icon: 'bi-clock', route_name: 'TimeSheets', count: null },
  { id: 'coordinator-reports', label: 'Scope reports', icon: 'bi-bar-chart', route_name: 'CompanyReports', count: null },
];

const SIDEBAR_ROUTE_QUERY_KEYS = ['status', 'filter', 'inbox_group', 'open_new_case'];
const PROJECT_ID_KEYS = [
  'project_id',
  'projectId',
  'tenant_id',
  'selected_project_id',
  'current_project_id',
  'active_project_id',
];

const ROUTE_PROJECT_ID_READERS = [
  (route) => route?.query?.project_id,
  (route) => route?.query?.projectId,
  (route) => route?.query?.tenant_id,
  (route) => route?.query?.selected_project_id,
  (route) => route?.query?.current_project_id,
  (route) => route?.query?.active_project_id,
  (route) => route?.params?.project_id,
  (route) => route?.params?.projectId,
  (route) => route?.params?.tenant_id,
  (route) => route?.params?.selected_project_id,
  (route) => route?.params?.current_project_id,
  (route) => route?.params?.active_project_id,
];

const ROUTE_QUERY_READERS = new Map([
  ['status', (route) => route?.query?.status],
  ['filter', (route) => route?.query?.filter],
  ['inbox_group', (route) => route?.query?.inbox_group],
  ['open_new_case', (route) => route?.query?.open_new_case],
]);

const ITEM_QUERY_READERS = new Map([
  ['status', (route_query) => route_query?.status],
  ['filter', (route_query) => route_query?.filter],
  ['inbox_group', (route_query) => route_query?.inbox_group],
  ['open_new_case', (route_query) => route_query?.open_new_case],
]);

function normalize_role(role) {
  return String(role || '').trim().toLowerCase();
}

function normalize_id(value) {
  const normalized_value = Number(value);
  return Number.isFinite(normalized_value) && normalized_value > 0 ? normalized_value : null;
}

function read_session_project_id() {
  if (typeof window === 'undefined') {
    return null;
  }

  for (const key of PROJECT_ID_KEYS) {
    const project_id = normalize_id(window.sessionStorage.getItem(key));
    if (project_id) {
      return project_id;
    }
  }

  return null;
}

export function route_project_id(route) {
  return ROUTE_PROJECT_ID_READERS
    .map((read_value) => read_value(route))
    .map(normalize_id)
    .find(Boolean) || read_session_project_id();
}

export function is_case_owner_role(role) {
  const normalized_role = normalize_role(role);
  return (
    normalized_role.includes('case owner')
    || normalized_role.includes('case_owner')
    || normalized_role === 'owner'
    || normalized_role.endsWith(' owner')
  );
}

export function is_requestor_role(role) {
  const normalized_role = normalize_role(role);
  return (
    normalized_role.includes('entity')
    || normalized_role === 'entity'
    || normalized_role.includes('requestor')
    || normalized_role.includes('requester')
    || normalized_role === 'requestor'
    || normalized_role === 'requester'
  );
}

export function is_intake_officer_role(role) {
  const normalized_role = normalize_role(role);
  return (
    normalized_role === 'intake'
    || normalized_role === 'intake officer'
    || normalized_role === 'intake_officer'
    || normalized_role === 'intake desk'
    || normalized_role.includes('intake officer')
    || normalized_role.includes('intake_officer')
    || normalized_role.includes('intake desk')
  );
}

export function is_coordinator_role(role) {
  const normalized_role = normalize_role(role);
  return (
    normalized_role.includes('coordinator')
    || normalized_role === 'coord'
    || normalized_role === 'coordinator'
  );
}

export function is_admin_role(role) {
  const normalized_role = normalize_role(role);
  return normalized_role.includes('admin') || normalized_role.includes('administrator');
}

export const build_case_owner_profile = ({
  current_lead_name = '',
  current_role = '',
  current_project_name = '',
  user_profile = null,
  case_count = null,
  inbox_count = null,
  status_items = [],
} = {}) => {
  const trusted_user_profile = user_profile;
  const user = trusted_user_profile?.user || trusted_user_profile || {};
  const name = first_non_empty([
    user_full_name(user),
    user.name,
    user.full_name,
    current_lead_name,
    user.email,
    'Case Owner',
  ]);
  const role_label = first_non_empty([
    role_name_from_user_profile(trusted_user_profile),
    current_role,
    'Case Owner',
  ]);
  const scope_label = first_non_empty([
    trusted_user_profile?.role_group_name,
    trusted_user_profile?.entity_type_name,
    trusted_user_profile?.project_name,
    trusted_user_profile?.project?.project_name,
    trusted_user_profile?.project?.name,
    current_project_name,
    'Workspace',
  ]);
  const email = first_non_empty([session_value('user_email'), user.email, trusted_user_profile?.email]);
  const phone_number = first_non_empty([trusted_user_profile?.phone_number, user.phone_number]);
  const open_cases = count_label(case_count);
  const snapshot = case_snapshot_from_status_items(status_items, inbox_count);

  const profile = {
    initials: initials_from_name(name),
    name,
    edit_profile: {
      user_id: first_non_empty([trusted_user_profile?.user_id, user.id]),
      first_name: first_non_empty([user.first_name, first_name_from_name(name)]),
      last_name: first_non_empty([user.last_name, last_name_from_name(name)]),
      email,
      phone_number,
      role_id: first_non_empty([trusted_user_profile?.role_id, user.role_id, trusted_user_profile?.role?.id, user.role?.id]),
    },
    role_label: role_label || 'Not recorded',
    scope_label: scope_label || 'Not recorded',
    metrics: profile_sidebar_metrics(open_cases, trusted_user_profile),
    metric_cards: [
      { label: 'Open caseload', value: open_cases, detail: first_non_empty([trusted_user_profile?.caseload_meta, 'Within capacity (165)']) },
      { label: 'SLA compliance', value: first_non_empty([trusted_user_profile?.sla, '0%']), detail: first_non_empty([trusted_user_profile?.sla_detail]) },
      { label: 'Avg. resolution', value: first_non_empty([trusted_user_profile?.average_resolution, trusted_user_profile?.avg_resolution, '0d']), detail: first_non_empty([trusted_user_profile?.average_resolution_detail, trusted_user_profile?.avg_resolution_detail]) },
      { label: 'Override rate', value: first_non_empty([trusted_user_profile?.override_rate, '0%']), detail: first_non_empty([trusted_user_profile?.override_rate_detail]) },
    ],
    contact_rows: [
      { label: 'Email', value: email || 'Not recorded' },
      { label: 'Mobile', value: phone_number || 'Not recorded' },
      { label: 'Coordinator', value: first_non_empty([trusted_user_profile?.coordinator, trusted_user_profile?.coordinator_name]) || 'Not recorded' },
      { label: 'Working hours', value: trusted_user_profile?.working_hours || 'Not recorded' },
      { label: 'Onboarded', value: first_non_empty([formatted_date(trusted_user_profile?.onboarded_at), formatted_date(trusted_user_profile?.onboarding_date), formatted_date(trusted_user_profile?.onboarded_date)]) || 'Not recorded' },
      { label: 'Out-of-office', value: first_non_empty([trusted_user_profile?.out_of_office, trusted_user_profile?.availability]) || 'Not recorded' },
    ],
    specialties: specialty_tags(trusted_user_profile),
    authorisation_cap: first_non_empty([trusted_user_profile?.authorisation_cap, trusted_user_profile?.authorization_cap]) || 'Not recorded',
    fais: first_non_empty([trusted_user_profile?.fais, trusted_user_profile?.accreditation]) || 'Not recorded',
    cpd: first_non_empty([trusted_user_profile?.cpd, trusted_user_profile?.training_hours]) || 'Not recorded',
    case_snapshot: snapshot,
  };
  return profile;
};

function first_non_empty(values = []) {
  return values
    .map((value) => value === null || value === undefined ? '' : String(value).trim())
    .find(Boolean) || '';
}

function session_value(key) {
  if (typeof window === 'undefined') return '';
  return window.sessionStorage.getItem(key) || '';
}

function user_full_name(user = {}) {
  return [user.first_name, user.last_name].filter(Boolean).join(' ').trim();
}

function first_name_from_name(name = '') {
  return String(name || '').trim().split(/\s+/).filter(Boolean)[0] || '';
}

function last_name_from_name(name = '') {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  return parts.length > 1 ? parts.slice(1).join(' ') : '';
}

function role_name_from_user_profile(profile = {}) {
  const user = profile?.user || {};
  const role = user.role || profile?.role || {};
  return first_non_empty([role.role, role.role_name, role.name, user.role_name, profile?.role_name]);
}

function initials_from_name(name = '') {
  return String(name || '')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0))
    .join('')
    .toUpperCase() || 'CO';
}

function count_label(value) {
  return value === null || value === undefined || value === '' ? '0' : String(value);
}

function profile_sidebar_metrics(open_cases = '0', profile = {}) {
  return [
    { label: 'Cases', value: open_cases },
    { label: 'This wk', value: first_non_empty([profile?.this_week_hours, profile?.hours_this_week, '0h']) },
    { label: 'SLA', value: first_non_empty([profile?.sla, '0%']) },
  ];
}

function specialty_tags(profile = {}) {
  const profile_specialties = Array.isArray(profile?.specialties) ? profile.specialties : [];
  const normalized_specialties = profile_specialties
    .map((item) => typeof item === 'string' ? { label: item } : item)
    .filter((item) => item?.label);

  if (normalized_specialties.length) {
    return normalized_specialties.map((item) => ({
      ...item,
      badge_class: item.badge_class || 'bg-primary-subtle text-primary-emphasis',
    }));
  }

  return [];
}

function formatted_date(value = '') {
  if (!value) return '';

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';

  return date.toLocaleDateString('en-ZA', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });
}

function case_snapshot_from_status_items(status_items = [], inbox_count = null) {
  const live_status_items = Array.isArray(status_items)
    ? status_items
      .map((item) => ({
        label: first_non_empty([item.label, item.status, item.name]),
        value: count_label(item.count),
        border_class: status_border_class(item),
      }))
      .filter((item) => item.label)
    : [];

  if (live_status_items.length) {
    return live_status_items;
  }

  return [
    { label: 'Needs attention', value: count_label(inbox_count), border_class: 'is-warning' },
  ];
}

function status_border_class(item = {}) {
  const status = String(item.label || item.status || item.name || '').toLowerCase();

  if (status.includes('due') || status.includes('risk') || status.includes('overdue')) return 'is-danger';
  if (status.includes('pending') || status.includes('evidence')) return 'is-warning';
  if (status.includes('closed') || status.includes('complete')) return 'is-muted';
  return 'is-success';
}

export function build_case_owner_work_items(case_count = null, inbox_count = null) {
  return CASE_OWNER_WORK_ITEMS.map((item) => {
    if (item.id === 'owner-all-cases') {
      return {
        ...item,
        count: case_count === null ? null : String(case_count),
      };
    }

    if (item.id === 'owner-inbox') {
      return {
        ...item,
        count: inbox_count === null ? null : String(inbox_count),
      };
    }

    return item;
  });
}

export function build_requestor_work_items(case_count = null, inbox_count = null) {
  return REQUESTOR_WORK_ITEMS.map((item) => {
    if (item.id === 'requestor-all-cases') {
      return {
        ...item,
        count: case_count === null ? null : String(case_count),
      };
    }

    if (item.id === 'requestor-inbox') {
      return {
        ...item,
        count: inbox_count === null ? null : String(inbox_count),
      };
    }

    return item;
  });
}

export function build_coordinator_work_items(
  scope_case_count = null,
  intake_queue_count = null,
  inbox_count = null,
  panel_count = null,
  timesheet_count = null
) {
  return COORDINATOR_WORK_ITEMS.map((item) => {
    if (item.id === 'coordinator-cases') {
      return {
        ...item,
        count: scope_case_count === null ? null : String(scope_case_count),
      };
    }

    if (item.id === 'coordinator-intake') {
      return {
        ...item,
        count: intake_queue_count === null ? null : String(intake_queue_count),
      };
    }

    if (item.id === 'coordinator-inbox') {
      return {
        ...item,
        count: inbox_count === null ? null : String(inbox_count),
      };
    }

    if (item.id === 'coordinator-panel') {
      return {
        ...item,
        count: panel_count === null ? null : String(panel_count),
      };
    }

    if (item.id === 'coordinator-timesheets') {
      return {
        ...item,
        count: timesheet_count === null ? null : String(timesheet_count),
      };
    }

    return item;
  });
}

export function build_intake_officer_work_items(
  intake_queue_count = null,
  registered_case_count = null,
  inbox_count = null
) {
  return INTAKE_OFFICER_WORK_ITEMS.map((item) => {
    if (item.id === 'intake-queue') {
      return {
        ...item,
        count: intake_queue_count === null ? null : String(intake_queue_count),
      };
    }

    if (item.id === 'registered-cases') {
      return {
        ...item,
        count: registered_case_count === null ? null : String(registered_case_count),
      };
    }

    if (item.id === 'intake-inbox') {
      return {
        ...item,
        count: inbox_count === null ? null : String(inbox_count),
      };
    }

    return item;
  });
}

export function is_active_route(current_route, route_name, route_query = null) {
  if (current_route.name !== route_name) {
    return false;
  }

  if (!route_query) {
    return true;
  }

  return SIDEBAR_ROUTE_QUERY_KEYS.every((key) => {
    if (!Object.hasOwn(route_query, key)) {
      return true;
    }

    const read_current_value = ROUTE_QUERY_READERS.get(key);
    const read_expected_value = ITEM_QUERY_READERS.get(key);
    return String(read_current_value?.(current_route) || '') === String(read_expected_value?.(route_query) || '');
  });
}
